import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import Header from "./partials/header/header";
import { connectWithStore } from "../services/redux";
import Loader from "../components/loader/loader";
import Sidebar from "./partials/sidebar/sidebar";
import { JobType, Projects, UserAutocomplete } from "../redux/actions";
import { getJobTypeList } from "../services/api/job_type";
import { getAllProjectList } from "../services/api/projects";
import { getUsersDirectory } from "../services/api/user";
import NotificationsModal from "./partials/modals/user_notifications_modal";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastr";
import LoginService from "../services/login";
import { getFileTarget } from "../services/api/file_upload";
import { BigLoader } from "../components/loader/big_loader";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import samuraiTheme from "../theme/themes/mui_theme";

// A session can end while an authenticated screen is on the display: a 401
// makes the http interceptor dispatch LOGOUT, which empties `user`. Every
// screen under this layout reads that slice, so "is there still a session"
// has to be answered in one place rather than in each of them.
const hasSession = (user) =>
  Boolean(user && user.access_token && user.access_token.accessToken);

export class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttons: this.props.topNavMenu.buttons,
      showModalFunc: null,
      //showModalJobType: null,
      hideSidebar: null,
      theme: createTheme(samuraiTheme),
      themeInitiated: false,
    };
    getJobTypeList().then((list) => {
      this.props.dispatch(JobType.list({ list }));
      //this.setState({ loading: false });
    });
    getAllProjectList({}).then((list) => {
      const projectsList = list ? list.docs : [];
      this.props.dispatch(Projects.list(projectsList));
      this.setState({ loading: false });
    });
    getUsersDirectory({ page_size: 100 }).then((response) => {
      const transformedUsersList =
        response.docs && response.docs.length > 0
          ? response.docs.map((user) => {
              const hasName = user.name && user.name.first && user.name.last;
              if (hasName) {
                return {
                  value: user._id,
                  label: user.name.first + " " + user.name.last,
                  subLabel: user.email,
                  avatar: user.imgUrl,
                  role: user.role,
                  inTraining: user.inTraining,
                  skills: user.skills,
                };
              } else {
                return {
                  value: user._id,
                  label: user.email,
                  avatar: user.imgUrl,
                  role: user.role,
                  inTraining: user.inTraining,
                  skills: user.skills,
                };
              }
            })
          : [];
      this.props.dispatch(
        UserAutocomplete.setInitialUsers(transformedUsersList)
      );
    });
    this.headerRef = null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!hasSession(nextProps.user)) {
      // Remember where they were headed. Every job link the system sends out
      // is a deep link (`/jobs/7350`), and bouncing to /auth used to discard
      // it — so after logging in you landed on the dashboard and the job you
      // were sent was simply gone. auth.js already reads `redirect_to`; until
      // now only the profile page ever wrote it.
      const { pathname, search } = nextProps.children.props.location || {};
      if (pathname && pathname !== "/" && !pathname.startsWith("/auth")) {
        localStorage.setItem(
          "redirect_to",
          `${pathname}${search || ""}`.replace(/^\//, "")
        );
      }
      nextProps.children.props.history.push("/auth");
      return null;
    }
    if (
      JSON.stringify(nextProps.topNavMenu.buttons) !==
      JSON.stringify(prevState.buttons)
    ) {
      return {
        buttons: nextProps.topNavMenu.buttons,
      };
    }
    return null;
  }

  componentDidUpdate() {
    const { theme, themeInitiated } = this.state;
    const { settings } = this.props;
    const primaryColor =
      settings &&
      settings.branding &&
      settings.branding.primary &&
      settings.branding.primary.color &&
      settings.branding.primary.color.hex;

    if (primaryColor && !themeInitiated) {
      const updatedTheme = { ...theme };
      updatedTheme.palette.primary.main = primaryColor;

      this.setState({
        themeInitiated: true,
        theme: updatedTheme,
      });
    }
  }

  render() {
    // getDerivedStateFromProps has already sent them to /auth by the time we
    // get here, but React still finishes this render pass — so the screen
    // underneath painted one more frame against a user that had just been
    // emptied. The job editor does `user.profile.id.toString()`, which threw
    // "Cannot read properties of undefined (reading 'toString')" into the
    // error boundary and dumped the user on /error/500 instead of the login
    // page; every other screen here reads the same slice and is one absent
    // field away from the same crash. Nothing is worth painting for a session
    // that no longer exists.
    if (!hasSession(this.props.user)) {
      return null;
    }

    const { loading, buttons, theme } = this.state;
    const { visible } = this.props.notificationPanel;

    return (
      <ThemeProvider theme={theme}>
        <div className="adminLayout">
          {this.props.loadingBarApp.showLoader && <BigLoader />}
          {/*isMobileDevice() && (
            <AddToHomeScreen
              appId="root"
              startAutomatically={true}
              startDelay={0}
              displayPace={10080}
              lifespan={60}
              skipFirstVisit={false}
              activateLogging={true}
              mustShowCustomPrompt={true}
              customPromptContent={{
                cancelMsg: "Not now",
                installMsg: "Install",
                guidanceCancelMsg: "",
              }}
            />
            )*/}
          <Helmet>
            <link
              rel="apple-touch-icon"
              href={
                this.props.settings.secondaryLogoUrl
                  ? getFileTarget(
                      this.props.settings.secondaryLogoUrl,
                      "100x100"
                    )
                  : "/logo.default.png"
              }
            />
            {LoginService.isImpersonating(this.props.settings) && (
              <style>{"body {background-color: #FFCCCC !important}"}</style>
            )}
            <script src="https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/build/pdf.min.js" />
          </Helmet>
          <ToastContainer
            ref={(ref) => (window.toast = ref)}
            className="toast-top-center"
          />
          <Loader store={this.props.store} />
          <Header
            modalNewPass={(func) => {
              this.setState({
                showModalFunc: func,
              });
            }}
            setHideFunction={(fn) => this.setState({ hideSidebar: fn })}
            buttons={buttons}
            {...this.props.children.props}
          />
          {!loading && (
            <Sidebar
              {...this.props.children.props}
              toggleModal={this.state.showModalFunc}
              closeMenu={this.state.hideSidebar}
            />
          )}
          <div
            className="admin-main"
            onClick={() => {
              if (this.state.hideSidebar) {
                this.state.hideSidebar();
              }
            }}
          >
            <div
              className="row container-fluid"
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <div
                className={
                  visible
                    ? "col-md-9 d-sm-block"
                    : "col-md-12  d-sm-block wrapper"
                }
              >
                {this.props.children}
              </div>
              <div
                style={{
                  display: !visible ? "none" : "block",
                }}
                className={
                  visible ? "col-md-3  d-sm-block NotificationPanelWrapper" : ""
                }
              >
                <NotificationsModal />
              </div>
            </div>
          </div>
          <ReactTooltip effect="solid" type="info" />
        </div>
      </ThemeProvider>
    );
  }
}

export default connectWithStore(AdminLayout, [
  "loadingBar",
  "user",
  "jobType",
  "topNavMenu",
  "notificationPanel",
  "settings",
  "loadingBarApp",
  "apps",
]);
